<template>
  <div>
    <q-dialog
      v-model="pagesUtilStore.showModalFilterInstitutional"
      :no-backdrop-dismiss="true"
    >
      <q-card class="midia-app-padding-modal" style="width: 500px; max-width: 80vw;">
        <div>
          <c-modal-title
            propModalTitle="Telas Institucionais"
            propModalDescription="Consulte e gerencie os cadastros de Telas Institucionais"
          />

          <!-- NOME DO CADASTRO -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Nome do Cadastro</span>
            </div>
            <q-input
              v-model="institutionalStore.institutionalFilter.nome"
              outlined
              dense
              color="globalAppPrimaryColor"
              style="width: 100%;"
              placeholder="Digite o nome do cadastro"
            />
          </div>

          <!-- STATUS -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Status</span>
            </div>
            <q-select
              v-model="institutionalStore.institutionalFilter.status"
              :options="optionsStatus"
              outlined
              option-label="description"
              option-value="id"
              map-options
              emit-value
              dense
              clearable
              color="globalAppPrimaryColor"
              style="width: 100%;"
              :label-slot="!institutionalStore.institutionalFilter.status"
            >
              <template v-slot:label>
                <span class="midia-app-placeholder-md">Selecione um Status</span>
              </template>
              <template v-slot:option="{ itemProps, opt }">
                <q-item v-bind="itemProps">
                  <q-item-section>
                    <q-item-label>{{ opt.description }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>

          <!-- TIPO (Telas Cadastradas) -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Tipo</span>
            </div>
            <q-select
              v-model="institutionalStore.institutionalFilter.telasCadastradas"
              :options="optionsTipo"
              outlined
              option-label="label"
              option-value="value"
              map-options
              emit-value
              dense
              clearable
              color="globalAppPrimaryColor"
              style="width: 100%;"
              :label-slot="!institutionalStore.institutionalFilter.tipo"
            >
              <template v-slot:label>
                <span class="midia-app-placeholder-md">Selecione um Tipo</span>
              </template>
            </q-select>
          </div>

          <!-- PERFIL -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Perfil</span>
            </div>
            <q-select
              v-model="institutionalStore.institutionalFilter.perfil"
              :options="optionsPerfil"
              outlined
              dense
              clearable
              color="globalAppPrimaryColor"
              style="width: 100%;"
              :label-slot="!institutionalStore.institutionalFilter.perfil"
            >
              <template v-slot:label>
                <span class="midia-app-placeholder-md">Selecione um Perfil</span>
              </template>
            </q-select>
          </div>

          <!-- REDE (fixa) -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Rede</span>
            </div>
            <q-input
              model-value="Banco24Horas"
              outlined
              dense
              readonly
              color="globalAppPrimaryColor"
              style="width: 100%;"
            />
          </div>

          <!-- SUBREDE -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Subrede </span>
            </div>
            <q-select
              v-model="institutionalStore.institutionalFilter.codSubrede"
              :options="optionsSubrede"
              outlined
              option-label="nomSubredeAutoAtndto"
              option-value="codSubredeAutoAtndto"
              map-options
              emit-value
              dense
              clearable
              color="globalAppPrimaryColor"
              style="width: 100%;"
              :label-slot="!institutionalStore.institutionalFilter.codSubrede"
            >
              <template v-slot:label>
                <span class="midia-app-placeholder-md">Selecione uma Subrede</span>
              </template>
            </q-select>
          </div>

          <!-- CÓDIGO DO PC -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Código do PC</span>
            </div>
            <q-input
              v-model="institutionalStore.institutionalFilter.codPc"
              outlined
              dense
              color="globalAppPrimaryColor"
              style="width: 100%;"
              placeholder="Digite o código do PC"
              type="number"
            />
          </div>

          <!-- GRANULARIDADE -->
          <div class="row col q-pb-md">
            <div class="row q-pb-xs">
              <span class="midia-app-label-modal-sm">Granularidade</span>
            </div>
            <q-select
              v-model="institutionalStore.institutionalFilter.granularidade"
              :options="optionsGranularidade"
              outlined
              option-label="label"
              option-value="value"
              map-options
              emit-value
              dense
              clearable
              color="globalAppPrimaryColor"
              style="width: 100%;"
              :label-slot="!institutionalStore.institutionalFilter.granularidade"
            >
              <template v-slot:label>
                <span class="midia-app-placeholder-md">Selecione a Granularidade</span>
              </template>
            </q-select>
          </div>


          

          <!-- PERÍODO -->
<div class="q-pb-md">
  <div class="row q-pb-xs">
    <span class="midia-app-label-modal-sm">Período</span>
  </div>
  <div class="flex items-center">
    <div style="width: 160px;">
      <q-input
        style="outline: 1px solid var(--globalAppSecondaryColor2);"
        v-model="institutionalStore.institutionalFilter.dt_ini_vigencia"
        bg-color="globalAppDefaultBackgroundColor"
        borderless
        dense
        readonly
        input-class="midia-app-content-lg"
      >
        <template v-slot:prepend>
          <q-icon class="cursor-pointer q-pa-sm q-mr-sm" style="background: var(--globalAppPrimaryColor);">
            <img class="svg-icon" src="@/assets/icons/icon_HiOutlineCalendar.svg" />
            <q-popup-proxy ref="qPopupProxyStartDate" cover transition-show="scale" transition-hide="scale">
              <q-date
                v-model="institutionalStore.institutionalFilter.dt_ini_vigencia"
                mask="DD/MM/YYYY"
                minimal
                :default-year-month="startDateDefaultYearMonth"
                color="globalAppPrimaryColor"
              >
                <div class="row items-center justify-end">
                  <ButtonCloseModal />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>

    <span class="midia-app-label-lg q-px-md">até</span>

    <div style="width: 160px;">
      <q-input
        style="outline: 1px solid var(--globalAppSecondaryColor2);"
        v-model="institutionalStore.institutionalFilter.dt_fim_vigencia"
        bg-color="globalAppDefaultBackgroundColor"
        borderless
        dense
        readonly
        input-class="midia-app-content-lg"
      >
        <template v-slot:prepend>
          <q-icon class="cursor-pointer q-pa-sm q-mr-sm" style="background: var(--globalAppPrimaryColor);">
            <img class="svg-icon" src="@/assets/icons/icon_HiOutlineCalendar.svg" />
            <q-popup-proxy ref="qPopupProxyEndDate" cover transition-show="scale" transition-hide="scale">
              <q-date
                v-model="institutionalStore.institutionalFilter.dt_fim_vigencia"
                mask="DD/MM/YYYY"
                minimal
                color="globalAppPrimaryColor"
              >
                <div class="row items-center justify-end">
                  <ButtonCloseModal />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
  </div>
</div>


          <c-q-separator class="q-pt-sm q-pb-lg" />

          <div class="row fit flex no-wrap justify-between q-pb-xs" style="width: 100%;">
            <div class="q-pr-sm">
              <c-q-btn
                id="btn-clear-filter"
                propBtnLabel="Limpar Filtros"
                :propBtnFunction="onClearFilterBtnClick"
                :propBtnTransparent="true"
                :propBtnSize="EnumButtonSizes.LARGE_1"
              />
            </div>

            <div class="col col-grow q-pl-sm">
              <c-q-btn
                id="btn-fetch-campaigns"
                style="width: 100%;"
                propBtnLabel="Buscar"
                :propBtnFunction="onFetchInstitutionalBtnClick"
                :propBtnTransparent="false"
                :propBtnSize="EnumButtonSizes.LARGE_1"
              />
            </div>

            <q-inner-loading
              :showing="pagesUtilStore.showLoadingModal"
              label="aguarde..."
            />
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup lang="ts">
import ButtonCloseModal from '@/components/ButtonCloseModal.vue'
import { EnumButtonSizes } from '@/enums/enums'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { ref, computed, onMounted } from 'vue'
import { QPopupProxy } from 'quasar'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const redeSubredeStore = useRedeSubredeStore()

const qPopupProxyStartDate: { value: QPopupProxy | null } = ref(null)
const qPopupProxyEndDate: { value: QPopupProxy | null } = ref(null)

// ✅ Carrega subredes ao abrir o modal
onMounted(async () => {
  if (!redeSubredeStore.subredes.length) {
    await redeSubredeStore.carregarSubredes()
  }
})

// ✅ Filtra apenas subredes da rede 10 (Banco 24H)
const optionsSubrede = computed(() =>
  redeSubredeStore.subredes.filter(s => s.codRedeAutoAtndto === 10)
)

const optionsStatus = computed(() => Object.values(CONST_INSTITUTIONAL_STATUS))

const optionsTipo = [
  { label: 'Telas Iniciais', value: 'INICIAL' },
  { label: 'Telas de Aguarde', value: 'AGUARDE' },
  { label: 'Tela de Abertura', value: 'ABERTURA' },
]

const optionsPerfil = ['Banco24Horas', 'ATM Manager']

const onClearFilterBtnClick = () => {
  institutionalStore.resetInstitutionalFilter()
}

const formatDateToApi = (date?: string) => {
  if (!date || !date.includes('/')) return date
  const [day, month, year] = date.split('/')
  return `${year}-${month}-${day}` // ✅ DD/MM/YYYY → YYYY-MM-DD
}


const onFetchInstitutionalBtnClick = async () => {
  pagesUtilStore.showLoadingModal = true

  institutionalStore.institutionalFilter.dt_ini_vigencia = formatDateToApi(
    institutionalStore.institutionalFilter.dt_ini_vigencia
  )
  institutionalStore.institutionalFilter.dt_fim_vigencia = formatDateToApi(
    institutionalStore.institutionalFilter.dt_fim_vigencia
  )

  await institutionalStore.fetchInstitutionalScreens()
  pagesUtilStore.showModalFilterInstitutional = false
  pagesUtilStore.showLoadingModal = false
}

const startDateDefaultYearMonth = computed(() => {
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return formatter.format(now).split('/').reverse().join('/').substring(0, 7)
})

const optionsGranularidade = [
  { label: 'Por PC', value: 'Por PC' },
  { label: 'Por Subrede', value: 'Por Subrede' },
  { label: 'Por Rede', value: 'Por Rede' },
]


</script>
